<template>
    <section :id="'evento-'+ id" class="evento">
        <div class="data-evento">
            <p class="mes">{{ mes }}</p>
            <hr>
            <p class="dia">{{ data.dia }}</p>
        </div>
        <div class="imagem" :style="{ 'background-image': 'url(' + imagem + ')' }"></div>
        <div class="informacoes">
            <h2 class="nome">{{ nome }}</h2>

            <div class="data">
                <p>{{ data.dia }}/{{ data.mes }} {{ data.hora ? $t('evento.apartir') : '' }} {{ data.hora }}</p>
            </div>
            <p class="endereco">{{ $t('evento.endereco') }}: {{ endereco ? endereco: $t('evento.aconfirmar') }}</p>

            <p class="descricao" v-html="descricao"></p>

            <div class="valor">
                <p class="preco">Valor: {{ valor.preco ? 'R$ ' + valor.preco : $t('evento.aconfirmar') }}</p>
                <p class="preco-descricao"  v-html="valor.descricao"></p>
            </div>

            <div class="link" v-if="link.url">
                <a class="" :href="link.url">
                    {{ link.texto }}
                    <svg viewBox="0 0 512 512" width="24"><path d="M508.875,248.458l-160-160c-4.167-4.167-10.917-4.167-15.083,0c-4.167,4.167-4.167,10.917,0,15.083l141.792,141.792 H10.667C4.771,245.333,0,250.104,0,256s4.771,10.667,10.667,10.667h464.917L333.792,408.458c-4.167,4.167-4.167,10.917,0,15.083 c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125l160-160C513.042,259.375,513.042,252.625,508.875,248.458z"/></svg>
                </a>
            </div>
        </div>
    </section>
</template>

<script>

import JsonListaMeses from '@/assets/json/listaMeses.json'

export default {
    props: ['id', 'nome', 'imagem', 'data', 'descricao', 'valor', 'endereco', 'link'],
    data () {
        return {
            meses: JsonListaMeses,
            mes: ''
        }
    },
    methods: {
        /**
         * Return first 3 chars of month name
         */
        getMonth (month) {
            return this.meses[month].substring(0, 3).toUpperCase()
        }
    },
    mounted () {
        this.mes = this.getMonth(this.data.mes)
    }

}
</script>

<style lang="sass">
    @import "../../../assets/sass/_mixin"
    .evento
        display: flex
        flex-direction: row
        border-top: 1px solid gray
        border-bottom: 1px solid gray
        padding-top: 35px
        padding-bottom: 35px
        margin-top: -1px
        @include device(mobile)
            &
                flex-direction: column
        .data-evento
            min-width: 70px
            max-width: 70px
            margin-right: 100px
            @include device(mobile)
                &
                    padding-right: 0px
                    flex-direction: row-reverse
                    display: flex
                    align-items: flex-end
                    justify-content: flex-end
                    margin-bottom: 10px
                    margin-right: 0px
                    min-width: 100%
                    max-width: 100%
            hr
                margin: 0
                width: 25px
                border-top: 2px solid black
                @include device(mobile)
                    &
                        display: none
            .mes
                font-size: 18px
                font-weight: 600
                margin-bottom: 0px
                color: black
                @include device(mobile)
                    &
                    margin-left: 5px
            .dia
                font-size: 50px
                margin-bottom: 0
                color: black
                line-height: 1.2
                @include device(mobile)
                    &
                        line-height: 1
                        font-size: 40px
        .nome
            margin-bottom: 20px
        .data p
            margin-bottom: 0
        .imagem
            width: 400px
            min-width: 400px
            height: 350px
            background-color: gray
            background-position: center
            background-size: cover
            @include device(mobile)
                &
                    height: 250px
                    width: 100%
                    min-width: 100%
                    margin: 10px 0
        .informacoes
            padding-left: 60px
            flex-grow: 1
            @include device(mobile)
                &
                    padding-left: 0px
        .descricao
            padding: 8px 0
        .valor
            .preco
                margin-bottom: 0
        .link
            border-top: 1px solid black
            padding-top: 15px
            margin-top: 20px
</style>
